import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import AppPrivacyPolicy from './pages/AppPrivacyPolicy';
import AppTermsOfUse from './pages/AppTermsOfUse';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/:appSlug/privacy-policy" element={<AppPrivacyPolicy />} />
        <Route path="/:appSlug/terms-of-use" element={<AppTermsOfUse />} />
      </Routes>
    </Router>
  );
}

export default App;
